export default __webpack_public_path__ + "static/media/Piano.d94cf3ff.mp3";